__webpack_require__.p = "https://bmidxbczechiaplprod.netlify.app/";